import getBanner, { ReqGetBanner, ResGetBanner } from '@/service/layout/getBanner';
import { useViewportStore } from '@/store/useViewportStore';
import { useQuery } from '@tanstack/react-query';
import { RQLayoutKey } from './RQLayoutKey';

const useBannerQuery = ({ bannerType, exposePosition, detailPlatformType }: ReqGetBanner) => {
  const isMobile = useViewportStore((store) => store.isMobile);
  const sizeType = isMobile ? 'MOBILE' : 'WEB';

  return useQuery<ResGetBanner, Error, ResGetBanner['result']>({
    queryKey: RQLayoutKey['banner'](bannerType, exposePosition, sizeType, detailPlatformType),
    queryFn: () => getBanner({ bannerType, exposePosition, sizeType, detailPlatformType }),
    select: (data) => {
      return data.result;
    },
    staleTime: 1000 * 60 * 60 * 1, // 1시간
    gcTime: 1000 * 60 * 60 * 2, // 2시간
  });
};

export default useBannerQuery;
